// src/lib/idbSchema.js
//
// Single source of truth for the IndexedDB schema.
// Both localCache.js and outbox.js import getDb() from here.
//
// Why: IndexedDB's `upgrade` callback only fires once per version bump,
// no matter how many `openDB` calls happen. If two files each try to
// own the upgrade, whichever opens first wins and the other's stores
// never get created. By centralizing the schema here, we guarantee
// every store exists regardless of who opens the DB first.

import { openDB } from 'idb'

const DB_NAME = 'deathcard'
const DB_VERSION = 2
const CACHE_STORES = [
  'users',
  'events',
  'event_factions',
  'event_players',
  'bounties',
  'player_stats',
  'kill_log',
  'team_members',
  'bounty_pursuits',
  'org_members',
]

// Outbox is keyed by an auto-incrementing local id, not row.id from
// Supabase. Has secondary indexes on status and created_at for
// efficient queue draining.
const OUTBOX_STORE = 'outbox'

let dbPromise = null

export function getDb() {
  if (!dbPromise) {
    dbPromise = openDB(DB_NAME, DB_VERSION, {
      upgrade(db) {
        // Cache stores
        for (const storeName of CACHE_STORES) {
          if (!db.objectStoreNames.contains(storeName)) {
            db.createObjectStore(storeName, { keyPath: 'id' })
          }
        }
        // Outbox store with indexes
        if (!db.objectStoreNames.contains(OUTBOX_STORE)) {
          const store = db.createObjectStore(OUTBOX_STORE, {
            keyPath: 'id',
            autoIncrement: true,
          })
          store.createIndex('status', 'status')
          store.createIndex('created_at', 'created_at')
        }
      },
      blocked() {
        console.warn('[idbSchema] DB upgrade blocked by another tab')
      },
      blocking() {
        console.warn('[idbSchema] this tab is blocking a DB upgrade elsewhere')
      },
      terminated() {
        console.warn('[idbSchema] DB connection terminated unexpectedly')
        dbPromise = null
      },
    })
  }
  return dbPromise
}

export const STORES = {
  CACHE: CACHE_STORES,
  OUTBOX: OUTBOX_STORE,
}